/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IdDto } from './IdDto';
import type { OfferItemDetails } from './OfferItemDetails';
import type { OfferTranslation } from './OfferTranslation';

export type OfferDetails = {
    id: string;
    order: number;
    name?: string;
    status: OfferDetails.status;
    imageMetadataId?: string;
    effectiveFrom?: string;
    effectiveTo?: string;
    displayFrom?: string;
    receiptAcceptanceDaysThreshold?: number;
    rewardScope: OfferDetails.rewardScope;
    isParticipation?: boolean;
    type?: OfferDetails.type;
    isRiceCalculationEnabled?: boolean;
    priceLow?: number;
    priceHigh?: number;
    quantity?: number;
    regions?: Array<'AB' | 'BC' | 'MB' | 'NB' | 'NL' | 'NT' | 'NS' | 'NU' | 'ON' | 'TB' | 'PE' | 'QC' | 'SK' | 'YT'>;
    maxRedeemsPerCollector?: number;
    displayRetailers?: Array<IdDto>;
    isExclusiveForRetailer: boolean;
    translations?: Array<OfferTranslation>;
    displayPriorityZoneId: number;
    miles: number;
    offerCode?: string;
    sponsorCode: string;
    items?: Array<OfferItemDetails>;
};

export namespace OfferDetails {

    export enum status {
        DRAFT = 'DRAFT',
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
        EXPIRED = 'EXPIRED',
        UPCOMING = 'UPCOMING',
    }

    export enum rewardScope {
        RECEIPT = 'RECEIPT',
        LINE_ITEM = 'LINE_ITEM',
    }

    export enum type {
        SINGLE = 'SINGLE',
        PARTICIPATION = 'PARTICIPATION',
        BASE_SPENT = 'BASE_SPENT',
    }


}

